import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection'
import ContingentPlan from '../models/ContingentPlan'
import Obscura from "../../vendor/Backbone.Obscura";
import _ from "underscore";
import {getContingentPlanNetworkId} from "../views/contingents/PlantoolView";

const ContingentPlansProxy = Obscura.extend({
    filterByNetwork(network) {
        return this.filterBy('network', (model) => {
            let itemNetwork = getContingentPlanNetworkId(model);
            return (itemNetwork === Number(network));
        });
    },

    getFilterCount () {
        return this.getFilters().length
    },
});

export default InboomaBaseAsyncCollection.extend({
  
    collectionName : 'contingentPlans',
    model : ContingentPlan,
    url : '/contingent_plans',
    proxy: ContingentPlansProxy,

    _pagination : {
        // Updated after each request (response.pagination)
        current_page : 0,
        sort : 'date',
        sortDirection : 'desc',
        has_next_page : false,
        has_prev_page : false,
        count : 0, // not relevant; response total entities count
        limit : 500
    },    

});